import { ConfirmDeleteDialog } from '@/components/ConfirmDeleteDialog';
import { useRetainedValue } from '@/hooks/useRetainedValue';
import { useDeleteTravelEsim } from '@/hooks/useTravelEsimOrderActions';
import type { OrganizationTravelEsim } from '@octave/contracts';

interface DeleteTravelEsimDialogProps {
  /** The eSIM to delete; the dialog is closed when null. */
  esim: OrganizationTravelEsim | null;
  onClose: () => void;
  onDeleted?: () => void;
}

/** Octave admin: confirm the deletion of an international eSIM. */
export function DeleteTravelEsimDialog({
  esim,
  onClose,
  onDeleted,
}: DeleteTravelEsimDialogProps) {
  const { mutate: deleteTravelEsim, isPending } = useDeleteTravelEsim();
  const shown = useRetainedValue(esim);

  const confirm = () => {
    if (!esim) return;
    deleteTravelEsim(esim.id, {
      onSuccess: () => {
        onClose();
        onDeleted?.();
      },
    });
  };

  return (
    <ConfirmDeleteDialog
      open={esim !== null}
      title="Supprimer l'eSIM internationale"
      description={
        <>
          L'eSIM de <strong>{shown?.beneficiary.name}</strong> et ses forfaits
          seront supprimés, ainsi que les commandes qui ne contiennent rien
          d'autre. Cette action est irréversible.
        </>
      }
      isPending={isPending}
      onConfirm={confirm}
      onCancel={onClose}
    />
  );
}
